/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequestGroup } from '../../models/course-request-group';

export interface ApiRequestCourseGetRequestGroupGet$Params {
  on_behalf_user_id?: string;
}

export function apiRequestCourseGetRequestGroupGet(http: HttpClient, rootUrl: string, params?: ApiRequestCourseGetRequestGroupGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroup>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseGetRequestGroupGet.PATH, 'get');
  if (params) {
    rb.query('on_behalf_user_id', params.on_behalf_user_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseRequestGroup>;
    })
  );
}

apiRequestCourseGetRequestGroupGet.PATH = '/api/Request/Course/GetRequestGroup';
